























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseProfilExclusion from '@/components/profilExclusion/edit/EditBaseProfilExclusion.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import * as rules from '@/utils/validationRules'
import { toSubArray, toNumberDictionary } from '@/utils/groupBy'
import { AloBase } from '@/models/alo/AloBase'

@Component({ 
  name: 'EditMarques',    
  components:{EditBaseProfilExclusion}
})
export default class EditMarques extends Vue {
  
  private profilExclusion = getDefaultAloProfilExclusion()  

  private search:string = ""
  private initialExcludedDic = {}
  private firstFilter:string = "^a"
  private tableauHeight = 400

  get title(){
    return `Sélection des marques à exclure : (${this.totalMarques} marques dont ${this.totalMarques - this.profilExclusion.mrqIds.length} inclue(s) et ${this.profilExclusion.mrqIds.length} exclue(s))`
  }
  

  ruleRequired(v:string) {    
    return rules.ruleRequired(v)
  }

   onResize() {                  
    //@ts-ignore    
    this.tableauHeight = this.$refs.baseEdit.$el.clientHeight - 360
  }


  edit(item:AloProfilExclusion) {    
    this.onResize()            
    this.search = ""
    this.firstFilter = ""
    const ignoreRefresh = this.profilExclusion.id == item.id
    this.profilExclusion =  (this.$refs.baseEdit as EditBaseProfilExclusion).edit(item)          
    if(!ignoreRefresh) this.initialExcludedDic = toNumberDictionary(this.profilExclusion.mrqIds,id => id)        
  }  
  
  get marqueFilters(){
    return [
      {libelle:'A', value:/^a/i},
      {libelle:'B', value:/^b/i},
      {libelle:'C', value:/^c/i},
      {libelle:'D', value:/^d/i},
      {libelle:'E', value:/^e/i},
      {libelle:'F', value:/^f/i},
      {libelle:'G', value:/^g/i},
      {libelle:'H', value:/^h/i},
      {libelle:'I', value:/^i/i},
      {libelle:'J', value:/^j/i},
      {libelle:'K', value:/^k/i},
      {libelle:'L', value:/^l/i},
      {libelle:'M', value:/^m/i},
      {libelle:'N', value:/^n/i},
      {libelle:'O', value:/^o/i},
      {libelle:'P', value:/^p/i},
      {libelle:'Q', value:/^q/i},
      {libelle:'R', value:/^r/i},
      {libelle:'S', value:/^s/i},
      {libelle:'T', value:/^t/i},
      {libelle:'U', value:/^u/i},
      {libelle:'V', value:/^v/i},
      {libelle:'W', value:/^w/i},
      {libelle:'X', value:/^x/i},
      {libelle:'Y', value:/^y/i},
      {libelle:'Z', value:/^z/i},
      {libelle:'Autres', value:/^[^a-z]/i},
      {libelle:'Tout', value:false},
    ]
  }

  get totalMarques(){
    return this.$store.myGetters.marquesList.length
  }

  get allMarquesList(){    
    return this.$store.myGetters.marquesList.filter(m => 
       ((!this.search || this.search.length == 0) && !this.firstFilter)
    || (!this.search && !!this.firstFilter && !!m.libelle.match(this.firstFilter))  
    || (!!this.search && this.search.length > 0 && m.libelle.indexOf(this.search) > -1) )
  }

  get aliveMarquesList(){    
    return this.allMarquesList.filter(m => m.mrqIsAlive)
  }

  get excludedMarquesList() {
    return this.allMarquesList.filter(m => !!this.excludedMarqueDic[m.id])
  }

  get includedMarquesList() {
    return this.aliveMarquesList.filter(m => !this.excludedMarqueDic[m.id])
  }

  get excludedMarqueDic(){
    return toNumberDictionary(this.profilExclusion.mrqIds,id => id)
  }

  onExcludeMarque(marque:AloBase){        
    if(!this.excludedMarqueDic[marque.id]) {
      this.profilExclusion.mrqIds.push(marque.id)
    }
  }
  
  onUnExcludeMarque(marque:AloBase){    
    const index = this.profilExclusion.mrqIds.findIndex(id => id == marque.id)
    if(index >= 0) {
      this.profilExclusion.mrqIds.splice(index,1)
    }
  }

  includeAll(){
    this.profilExclusion.mrqIds = []
  }
  excludeAll(){
    this.profilExclusion.mrqIds = this.$store.myGetters.marquesList.map(m => m.id)
  }

  exclude(marque:AloBase){
    if(!this.excludedMarqueDic[marque.id])  this.profilExclusion.mrqIds.push(marque.id)
  }

  include(marque:AloBase){
    if(!!this.excludedMarqueDic[marque.id])  this.profilExclusion.mrqIds.splice(this.profilExclusion.mrqIds.indexOf(marque.id),1)
  }

}
